import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { TransactionsService } from './transactions.service';
import { Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { AlertService } from 'ngx-alerts';  
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.css']
})
export class TransactionsComponent implements OnInit {
txhistory: any;
balance: any;
balanceusd: any;
currentprice: any;
  constructor(private  commonService: CommonService, private spinner: NgxSpinnerService,  private session: SessionStorageService, private transaction: TransactionsService, private routes: Router, private alertService: AlertService) { }

  ngOnInit() {
    if(this.session.retrieve('token')){
      this.commonService.tokenValidity().then((res: any) => {
        this.spinner.hide();
        }).catch((err: any) => {     
            this.alertService.danger(err.message);
            this.spinner.hide();
            this.routes.navigate(['/login']);
      });
    }else{      
      this.routes.navigate(['/login']);
    }
    this.spinner.show();
      this.transaction.getTransactions().then((res: any)  => {
        this.spinner.hide();
        this.txhistory = res.items
      }).catch((err: any)  => {
        this.spinner.hide();
      });
      this.transaction.getDetails().then((res: any)  => {
        this.spinner.hide();
        this.balance = res.availabletoken;
        this.currentprice = res.tokenrate;
        this.balanceusd = res.availabletokenusd;
      }).catch((err: any)  => {
        this.spinner.hide();
      });
      
  }

}
